/**
 * Guarantee Models
 * ข้อมูลการันตีสินค้า
 */

export const GUARANTEE_TYPES = {
  MONEY_BACK: 'money_back',
  QUALITY: 'quality',
  REPLACEMENT: 'replacement',
  SATISFACTION: 'satisfaction'
};

export const GUARANTEE_TEMPLATES = {
  [GUARANTEE_TYPES.MONEY_BACK]: {
    type: GUARANTEE_TYPES.MONEY_BACK,
    name: '100% Money Back Guarantee',
    description: 'คืนเงิน 100% ภายใน {days} วัน',
    percentage: 100,
    defaultDays: 7,
    icon: '💰',
    color: 'green',
    conditions: [
      'สินค้าต้องอยู่ในสภาพเดิม',
      'ต้องมีใบเสร็จ',
      'ไม่เกิน {days} วันหลังจากรับสินค้า'
    ]
  },
  [GUARANTEE_TYPES.QUALITY]: {
    type: GUARANTEE_TYPES.QUALITY,
    name: 'Quality Guarantee',
    description: 'การันตีคุณภาพตามที่ระบุ',
    icon: '⭐',
    color: 'blue',
    conditions: [
      'คุณภาพตรงตามที่ระบุ',
      'สามารถตรวจสอบได้',
      'มีใบรับรองคุณภาพ'
    ]
  },
  [GUARANTEE_TYPES.REPLACEMENT]: {
    type: GUARANTEE_TYPES.REPLACEMENT,
    name: 'Free Replacement Guarantee',
    description: 'เปลี่ยนสินค้าฟรี ภายใน {days} วัน',
    defaultDays: 7,
    icon: '🔄',
    color: 'purple',
    conditions: [
      'เปลี่ยนสินค้าฟรี',
      'ภายใน {days} วัน',
      'สินค้าต้องมีปัญหา'
    ]
  },
  [GUARANTEE_TYPES.SATISFACTION]: {
    type: GUARANTEE_TYPES.SATISFACTION,
    name: 'Satisfaction Guarantee',
    description: 'การันตีความพึงพอใจ',
    icon: '😊',
    color: 'yellow',
    conditions: [
      'การันตีความพึงพอใจ',
      'คืนสินค้าง่าย ไม่ยุ่งยาก'
    ]
  }
};

/**
 * Create Guarantee Model
 */
export const createGuaranteeModel = (data) => {
  const template = GUARANTEE_TEMPLATES[data.type] || GUARANTEE_TEMPLATES[GUARANTEE_TYPES.MONEY_BACK];
  
  return {
    type: data.type,
    name: data.name || template.name,
    description: data.description || template.description.replace('{days}', data.days || template.defaultDays || 7),
    percentage: data.percentage || template.percentage || 100,
    days: data.days || template.defaultDays || 7,
    conditions: data.conditions || template.conditions.map(c => c.replace('{days}', data.days || template.defaultDays || 7)),
    icon: data.icon || template.icon,
    color: data.color || template.color,
    isActive: data.isActive !== undefined ? data.isActive : true,
    createdAt: data.createdAt || new Date(),
    updatedAt: new Date()
  };
};

/**
 * Get Guarantee Display Name
 */
export const getGuaranteeDisplayName = (type) => {
  return GUARANTEE_TEMPLATES[type]?.name || type;
};

/**
 * Get Guarantee Icon
 */
export const getGuaranteeIcon = (type) => {
  return GUARANTEE_TEMPLATES[type]?.icon || '🛡️';
};

/**
 * Get Guarantee Color
 */
export const getGuaranteeColor = (type) => {
  const colors = {
    green: 'bg-green-100 text-green-800 border-green-300',
    blue: 'bg-blue-100 text-blue-800 border-blue-300',
    purple: 'bg-purple-100 text-purple-800 border-purple-300',
    yellow: 'bg-yellow-100 text-yellow-800 border-yellow-300'
  };
  return colors[GUARANTEE_TEMPLATES[type]?.color || 'green'] || colors.green;
};







